import gsap from 'gsap'
import Swiper from "swiper"
import { ScrollTrigger } from 'gsap/ScrollTrigger'
import { Navigation, Pagination, Thumbs, Mousewheel, FreeMode, EffectFade, Autoplay } from "swiper/modules"
import lottie from 'lottie-web';
gsap.registerPlugin(ScrollTrigger)

import "swiper/css"
import "swiper/css/navigation"
import "swiper/css/pagination"
import "swiper/css/mousewheel"
import "swiper/css/free-mode"
import "swiper/css/thumbs"
import "swiper/css/effect-fade"

export const swiper = () => {
	leadership()
	team()
	insights()
	projects()
	homeBanner()
}

const leadership = () => {

	let el = document.querySelector('[data-swiper="leadership"]'),
		animations = []

	if (!el || window.innerWidth < 782) return false

	let carousel = new Swiper(el, {
		modules: [Navigation, EffectFade, FreeMode, Thumbs],
		// loop: true,
		slidesPerView: 1.25,
		spaceBetween: 24,
		freeMode: true,
		effect: 'fade',
		allowTouchMove: false,
		noSwiping: true,
		breakpoints: {
			782: {
				freeMode: false,
				slidesPerView: 1,
				effect: 'fade',
			},
		},
	})

	let tl = gsap.timeline({
		scrollTrigger: {
			trigger: el,
			start: 'center center',
			end: '+=3000',
			pin: true,
			scrub: true,
			// markers: true,
			onUpdate: self => {
				let progress = self.progress,
					totalIntervals = carousel.slides.length,
					intervalSize = 1 / totalIntervals,
					currentInterval = Math.floor(progress / intervalSize)
				if (currentInterval !== self.lastInterval) {
					carousel.slideTo(currentInterval)
					self.lastInterval = currentInterval
				}
			}
		},
	})

	carousel.slides.forEach((slide, i) => {

		let signature = slide.querySelector('[data-lottie]'),
			bar = slide.querySelector('[data-el="progress"]')

		tl.fromTo(bar, {
			scaleX: 0,
		}, {
			scaleX: 1,
			ease: 'none',
		})

		if (signature) {
			animations[i] = lottie.loadAnimation({
				container: signature,
				renderer: 'svg',
				loop: false,
				autoplay: false,
				path: signature.getAttribute('data-lottie'),
			})
		}
	})

	carousel.on('slideChange', slide => {
		animations[slide.activeIndex].goToAndPlay(0)
	})

	ScrollTrigger.create({
		trigger: el,
		start: 'top 75%',
		end: 'bottom 50%',
		// markers: true,
		onEnter: () => {
			animations[0].goToAndPlay(0)
		},
	})
}

const team = () => {

	let el = document.querySelector('[data-swiper="team"]')

	if (!el) return false

	new Swiper(el, {
		modules: [Navigation],
		slidesPerView: 2,
		spaceBetween: 12,
		loop: true,
		// touchStartForcePreventDefault: false,
		// touchStartPreventDefault: false,
		navigation: {
			prevEl: ".swiper-team-button.prev",
			nextEl: ".swiper-team-button.next",
		},
		breakpoints: {
			782: {
				slidesPerView: 3,
				spaceBetween: 24,
			},
			1280: {
				slidesPerView: 4,
			}
		},
	})
}

const insights = () => {

	let el = document.querySelector('[data-swiper="insights"]')

	if (!el) return

	new Swiper(el, {
		slidesPerView: 1.5,
		spaceBetween: 12,
		breakpoints: {
			782: {
				slidesPerView: 2,
				spaceBetween: 24,
			},
			960: {
				slidesPerView: 3,
			},
			960: {
				slidesPerView: 4,
			},
		}
	})
}

const projects = () => {

	let el = document.querySelector('[data-swiper="projects"]')

	if (!el) return

	new Swiper(el, {
		modules: [Navigation, FreeMode, Mousewheel],
		slidesPerView: 'auto',
		loop: true,
		freeMode: {
			enabled: true,
			// momentumVelocityRatio: 10,
			// sticky: true,
		},
		centeredSlides: true,
		mousewheel: true,
		navigation: {
			nextEl: ".swiper-button.next",
			prevEl: ".swiper-button.prev",
		},
		breakpoints: {
			782: {

			}
		}
	})
}

const homeBanner = () => {

	let el = document.querySelector('[data-swiper="home-banner"]')

	if (!el) return

	new Swiper(el, {
		modules: [Autoplay, EffectFade],
		loop: true,
		autoplay: {
			delay: 6000,
		},
		effect: 'fade',
		speed: 1000,
	})
}

export default () => { }